import { render } from "./MyPanel.vue?vue&type=template&id=32a75790"
import script from "./MyPanel.vue?vue&type=script&lang=js"
export * from "./MyPanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__